import {
  BooleanField,
  BooleanInput,
  Create,
  CreateButton,
  Datagrid,
  Edit,
  FilterButton,
  FormTab,
  FunctionField,
  List,
  NumberField,
  NumberInput,
  SearchInput,
  SelectInput,
  TextField,
  TextInput,
  TopToolbar,
  required,
  regex,
} from "react-admin";
import { useCommonLabels } from "../i18n/hooks";
import { FilePreviewLink } from "../ui/fileUpload";
import { FormSection } from "../ui/forms/FormSection";
import { BodyLangFields, TitleLangFields } from "../ui/forms/langFields";
import { LangTabbedForm } from "../ui/forms/LangTabbedForm";
import { LocalizedFileControls, LocalizedFileLangField } from "../ui/forms/LocalizedFileInput";
import { normalizeContentRecord } from "../ui/forms/normalizeMedia";
import CoverTextColorField from "../ui/forms/CoverTextColorField";

const ACTIVE_FILTER_CHOICES = [
  { id: true, name: "Aktiv" },
  { id: false, name: "Deaktiv" },
];

const ListActions = () => (
  <TopToolbar>
    <FilterButton />
    <CreateButton />
  </TopToolbar>
);

const PhGameForm = () => {
  const c = useCommonLabels();
  return (
    <LangTabbedForm>
      <FormTab label="Общее">
        <FormSection title="Oyun">
          <TextInput
            source="GameUrl"
            label="Oyun URL"
            fullWidth
            validate={[required(), regex(/^https?:\/\/.+/i, "Düzgün URL daxil edin")]}
            helperText="Məs: https://azdimension.az/games/FoodOnPlate/"
          />
          <NumberInput source="SortOrder" label="Порядок" defaultValue={0} fullWidth />
          <BooleanInput source="Active" label={c.active} defaultValue />
        </FormSection>
        <FormSection title="Изображение">
          <LocalizedFileControls
            baseSource="Image"
            label={c.image}
            kind="image"
            helperText="JPG/PNG или https:// URL обложки"
          />
          <CoverTextColorField />
        </FormSection>
      </FormTab>
      <FormTab label="🇦🇿 AZ">
        <TitleLangFields lang="AZ" titleRequired />
        <BodyLangFields lang="AZ" bodyRequired />
        <LocalizedFileLangField baseSource="Image" lang="AZ" label={c.image} kind="image" />
      </FormTab>
      <FormTab label="🇷🇺 RU">
        <TitleLangFields lang="RU" titleRequired />
        <BodyLangFields lang="RU" bodyRequired />
        <LocalizedFileLangField baseSource="Image" lang="RU" label={c.image} kind="image" />
      </FormTab>
      <FormTab label="🇬🇧 EN">
        <TitleLangFields lang="EN" titleRequired />
        <BodyLangFields lang="EN" bodyRequired />
        <LocalizedFileLangField baseSource="Image" lang="EN" label={c.image} kind="image" />
      </FormTab>
    </LangTabbedForm>
  );
};

export const PhGameList = () => {
  const c = useCommonLabels();
  const filters = [
    <SearchInput
      key="q"
      source="q"
      placeholder={`${c.search} (başlıq, mətn, URL)`}
      resettable
    />,
    <SelectInput
      key="active"
      source="active"
      label={c.status}
      choices={ACTIVE_FILTER_CHOICES}
      emptyText="Hamısı"
    />,
  ];

  return (
    <List
      filters={filters}
      sort={{ field: "SortOrder", order: "DESC" }}
      actions={<ListActions />}
    >
      <Datagrid rowClick="edit" bulkActionButtons={false}>
        <TextField source="Id" label="ID" />
        <TextField source="TitleRU" label="Заголовок" />
        <TextField source="GameUrl" label="URL" />
        <NumberField source="SortOrder" label="Sıra" />
        <FunctionField
          label={c.image}
          render={(record: { Image?: string }) => <FilePreviewLink value={record.Image} />}
        />
        <BooleanField source="Active" label={c.status} />
      </Datagrid>
    </List>
  );
};

export const PhGameEdit = () => (
  <Edit mutationMode="pessimistic" transform={normalizeContentRecord}>
    <PhGameForm />
  </Edit>
);

export const PhGameCreate = () => (
  <Create transform={normalizeContentRecord}>
    <PhGameForm />
  </Create>
);
